// === ROADMAP PUBLIQUE IN-GAME ===
// Contenu affiché dans RoadmapScene (accessible depuis le menu).
// Synthétique, joueur-friendly, sans spoilers majeurs.
// À mettre à jour à chaque release significative.

export type RoadmapStatus = 'done' | 'inprogress' | 'planned' | 'envisaged';

export interface RoadmapEntry {
  id: string;
  status: RoadmapStatus;
  emoji: string;
  title: string;
  /** Date approximative, vague volontairement ("Disponible", "Courant 2026", "2027"…) */
  date: string;
  /** Résumé en 1 ligne — affiché en gras sous le titre */
  summary: string;
  /** Détails courts, 3-6 bullets max, langage joueur */
  bullets: string[];
}

/** Couleurs et libellés des statuts (utilisés par RoadmapScene) */
export const STATUS_INFO: Record<RoadmapStatus, { label: string; color: string; bg: string; border: number }> = {
  done:        { label: '✅ Disponible',  color: '#2ecc71', bg: '#1a2a1a', border: 0x2ecc71 },
  inprogress:  { label: '⏳ En cours',    color: '#f39c12', bg: '#2a2010', border: 0xf39c12 },
  planned:     { label: '🔜 À venir',     color: '#3498db', bg: '#16243a', border: 0x3498db },
  envisaged:   { label: '🔮 Envisagé',    color: '#9b59b6', bg: '#221a2e', border: 0x9b59b6 },
};

export const PUBLIC_ROADMAP: RoadmapEntry[] = [
  {
    id: 'act1',
    status: 'done',
    emoji: '🏝️',
    title: 'Acte 1 — Le Rivage',
    date: 'Disponible',
    summary: 'L\'archipel maudit, votre terrain de chasse.',
    bullets: [
      '12 étages, 3 actes, 3 boss',
      '10 ennemis + 3 boss avec capacités spéciales',
      'Camp persistant (coffre, atelier, vigie, dortoir, autel)',
      '37 équipements + 6 consommables + craft',
      'Carte arborescente + nœuds de repos / marchand / events',
      'Mode extraction : quitter avant la mort, garder le butin',
    ],
  },
  {
    id: 'beta',
    status: 'inprogress',
    emoji: '🛠️',
    title: 'Bêta — Polish & Feedback',
    date: 'En cours — 2026',
    summary: 'On peaufine, on équilibre, on écoute vos retours.',
    bullets: [
      'Mutations de run (modificateurs roguelike)',
      'Bug reports & suggestions (boutons 🐛 / 💡)',
      'Équilibrage continu des combats et de l\'économie',
      'Adaptation mobile complète',
    ],
  },
  {
    id: 'island-refonte',
    status: 'inprogress',
    emoji: '🏝️',
    title: 'Refonte du Camp — Île pixel art',
    date: 'En cours — 2026',
    summary: 'Le Camp devient une vraie île qu\'on explore au point & click.',
    bullets: [
      'Vue top-down pixel art : plage, jungle, sentiers, rochers',
      'Capitaine déplaçable au clic, à pied',
      'Bâtiments cliquables avec marche jusqu\'à la porte (Sprint A2 ✅)',
      'États construit / fondations grisées par bâtiment (Sprint A2 ✅)',
      'Zone de départ raid via portail jungle + Chantier Naval verrouillé (Sprint B1 ✅)',
      'Menus diégétiques (panneau, table de navigation, feu de camp) + décorations (Sprint B1 ✅)',
      'Survivants visibles qui vivent leur vie sur l\'île (à venir)',
      'Activable en preview via le mode Dev (F1) — désactivé par défaut',
    ],
  },
  {
    id: 'act2',
    status: 'planned',
    emoji: '⛵',
    title: 'Acte 2 — L\'Expédition Maritime',
    date: 'Courant 2026',
    summary: 'Prenez le large. Nouveau théâtre, nouveau bateau.',
    bullets: [
      'Bateau craftable au camp (Chantier Naval)',
      'Postes d\'équipage : navigateur, canonnier, vigie…',
      'Combats sur ponts, abordages, créatures abyssales',
      'Nouvel acte avec sa propre carte et son boss final',
      'Items exclusifs (canons exotiques, voiles enchantées…)',
    ],
  },
  {
    id: 'act3',
    status: 'envisaged',
    emoji: '🏰',
    title: 'Acte 3 — Le Dernier Bastion',
    date: 'Horizon 2027',
    summary: 'Le contenu de prestige, calibré end-game.',
    bullets: [
      'Difficulté drastique : pour vétérans aguerris',
      'Nouvelles classes débloquées via les actes précédents',
      'Items légendaires drop boss-only',
      'Achievements end-game et défis spéciaux',
    ],
  },
  {
    id: 'cloud',
    status: 'envisaged',
    emoji: '☁️',
    title: 'Sauvegarde Cloud & Stats',
    date: 'Horizon 2027',
    summary: 'Vos parties suivent l\'équipage, partout.',
    bullets: [
      'Compte joueur léger (pseudo + email)',
      'Sync entre PC et mobile',
      'Stats agrégées anonymes pour piloter l\'équilibrage',
      'Mode hors ligne préservé',
    ],
  },
  {
    id: 'multi',
    status: 'envisaged',
    emoji: '👥',
    title: 'Multijoueur',
    date: 'À arbitrer',
    summary: 'Coop ou compétitif — la communauté décidera.',
    bullets: [
      'Coop : partagez un run avec un ou deux compagnons',
      'Compétitif : duels arène, leaderboards saisonniers',
      'Défis quotidiens à seed fixe',
      'Phase la plus ambitieuse — prérequis : sync cloud',
    ],
  },
];
